<template>
  <v-layout justify-start column style="background-color:#e6e6e6;" :class="{ mini: showMessageSidePanel }" >
    <!-- Navigation Drawer -->
    <v-navigation-drawer :mini-variant="showMessageSidePanel" mini-variant-width="55" class="sidebar-menu" v-model="drawer" app :mobile-break-point="960" dark>
      <v-layout >
     <MainMenu menuType="main"></MainMenu>
        <!-- <InCaseMenu></InCaseMenu>-->
      </v-layout>
    </v-navigation-drawer>

    <v-toolbar class="fixed-toolbar" fixed style="z-index:60" app clipped-left color="primary" height="50px">
      <v-toolbar-side-icon   dark @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-toolbar-side-icon>
      <div class="logo-wrapper" :style="$vuetify.breakpoint.smAndDown && 'width:auto'"><Logo></Logo></div>
      <v-layout row fluid>
        <v-flex shrink class="menu-toggle" >
            <span v-bind:class="{ active: !menuToggle }">Casework</span>
            <v-switch id="menuToggle" v-model="menuToggle" style="display:inline-block"></v-switch>
            <span v-bind:class="{ active: menuToggle }">Config</span>
        </v-flex>
        <v-flex grow class="search">
          <div class="search-wrapper">
            <search-bar></search-bar>
            <GlobalFAB></GlobalFAB>
          </div>
        </v-flex>
        <v-flex shrink>
          <v-tooltip color="secondary" bottom>
            <template v-slot:activator="{ on }">

              <v-btn v-on="on" dark icon class="ml-3 mt-2" v-on:click="showMessageSidePanel = !showMessageSidePanel"><v-icon>{{ showMessageSidePanel ? 'toggle_off' : 'toggle_on' }}</v-icon></v-btn>
            </template>
            <span>Toggle Mini-menu</span>
          </v-tooltip>
        </v-flex>
        <v-flex shrink class="account">
          <AccountFAB></AccountFAB>
        </v-flex>

      </v-layout>
    </v-toolbar>
    <v-content class="pt-0 p-relative">
    <v-flex class="offset-top"><!-- on case with summary fields row displayed, class of with-summary required -->
      <v-layout v-if="showMessageSidePanel">
          <v-flex lg8>
              <CaseEdit></CaseEdit>
          </v-flex>
          <v-flex lg4>
          <MessageSidePanel :message="messageForSidePanel"></MessageSidePanel>
          </v-flex>
         <!-- <v-flex lg6>
              <CaseEdit></CaseEdit>
          </v-flex>
          <v-flex lg6 class="p-relative">
          <case-document-side-panel></case-document-side-panel>
          </v-flex>-->
        </v-layout>
        <!-- <v-layout v-else>
          <v-flex>
             <CaseEdit></CaseEdit>
          </v-flex>
        </v-layout>-->

      <!-- Email compose window local -->
       <v-card
      class="fixed-email-window elevation-12"
      v-bind:class="{
        show: emailWindowToggled,
        fullscreen: fullscreenToggled,
        minimise: minimiseToggled,
      }"
    >
      <v-toolbar dark color="secondary">
        <h3 class="pr-4">Case Title - Title</h3>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-tooltip left color="secondary">
            <v-btn slot="activator" class="ma-0 mt-3 mr-1" icon dark>
              <v-icon>folder</v-icon>
            </v-btn>
            <span>Open new window</span>
          </v-tooltip>
          <v-tooltip left color="secondary">
            <v-btn slot="activator" class="ma-0 mt-3 mr-1" icon dark>
              <v-icon>folder_open</v-icon>
            </v-btn>
            <span>Open new tab</span>
          </v-tooltip>
          <v-tooltip left color="secondary" v-if="!fullscreenToggled">
            <v-btn
              slot="activator"
              class="ma-0 mt-3 mr-1"
              icon
              dark
              @click="minimiseToggled = !minimiseToggled"
            >
              <v-icon
                v-html="
                  minimiseToggled ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                "
              ></v-icon>
            </v-btn>
            <span>Minimise Window</span>
          </v-tooltip>
          <v-tooltip left color="secondary" v-if="!fullscreenToggled">
            <v-btn
              slot="activator"
              class="ma-0 mt-3 mr-1 make-fullscreen"
              icon
              dark
              @click="fullscreenToggled = true"
            >
              <v-icon>fullscreen</v-icon>
            </v-btn>
            <span>Toggle Fullscreen</span>
          </v-tooltip>
          <v-tooltip left color="secondary" v-if="fullscreenToggled">
            <v-btn
              slot="activator"
              class="ma-0 mt-3 mr-1 close-fullscreen"
              icon
              dark
              @click="fullscreenToggled = false"
            >
              <v-icon>fullscreen_exit</v-icon>
            </v-btn>
            <span>Exit Fullscreen</span>
          </v-tooltip>
          <v-tooltip left color="secondary" v-if="!compose">
            <v-btn
              slot="activator"
              class="ma-0 mt-3 mr-1"
              icon
              dark
              @click="emailWindowToggled = !emailWindowToggled"
            >
              <v-icon>close</v-icon>
            </v-btn>
            <span>Close Window</span>
          </v-tooltip>
        </v-toolbar-items>
      </v-toolbar>

      <v-flex px-4 pt-3 pb-2 v-if="compose">
       <v-autocomplete
          multiple
          label="To:"
          tabindex="1"
          no-data-text="Nothing match your search"
          append-icon
          dense
          class="no-margin-bottom custom-label with-btns"
         :items="people"
          item-text="name"
          item-value="name"
        >
        <!-- original from above v-autocomplete
        :items="allParticipants"
          item-text="displayName"
          item-value="index"
          -->
          <template slot="selection" slot-scope="data">
            <v-chip
                  close
                  dark
                  color="secondary"
                  class="chip--select-multi"
                >

                  {{ data.item.name }}
                </v-chip>
                   <!--<UserAvatar
              :userId="data.item.id"
              status="active"
              :avatarURL="data.item.avatarUrl"
              :name="data.item.displayName"
              size="40px"
            ></UserAvatar>-->
          </template>
          <template slot="append-outer">
            <div class="cc-bcc-buttons">
              <span class="cc-bcc"  @click="ccToggled = !ccToggled">Cc</span>
              <span class="cc-bcc ml-2"  @click="bccToggled = !bccToggled">Bcc</span>
            </div>
          </template>
        </v-autocomplete>
        <v-autocomplete
           v-if="ccToggled"
          multiple
          label="Cc:"
          tabindex="1"
          no-data-text="Nothing match your search"
          append-icon
          dense
          class="no-margin-bottom custom-label"
          :items="people"
          item-text="name"
          item-value="name"
        >
        <!-- original from above v-autocomplete
        :items="allParticipants"
          item-text="displayName"
          item-value="index"
          -->
          <template slot="selection" slot-scope="data">
             <v-chip
                  dark
                  color="secondary"
                  close
                  class="chip--select-multi"
                >

                  {{ data.item.name }}
                </v-chip>
                  <!--<UserAvatar
              :userId="data.item.id"
              status="active"
              :avatarURL="data.item.avatarUrl"
              :name="data.item.displayName"
              size="40px"
            ></UserAvatar>-->
          </template>
        </v-autocomplete>
        <v-autocomplete
           v-if="bccToggled"
          multiple
          label="Bcc:"
          tabindex="1"
          no-data-text="Nothing match your search"
          append-icon
          dense
          class="no-margin-bottom custom-label"
          :items="people"
          item-text="name"
          item-value="name"
        >
        <!-- original from above v-autocomplete
        :items="allParticipants"
          item-text="displayName"
          item-value="index"
          -->
          <template slot="selection" slot-scope="data">
           <v-chip
           dark
              color="secondary"
                  close
                  class="chip--select-multi"
                >
                  {{ data.item.name }}
                </v-chip>
            <!--<UserAvatar
              :userId="data.item.id"
              status="active"
              :avatarURL="data.item.avatarUrl"
              :name="data.item.displayName"
              size="40px"
            ></UserAvatar>-->
          </template>
        </v-autocomplete>
        <v-text-field
          label="Subject"
          tabindex="1"
          v-model="subject"
          class="custom-label text no-margin-bottom"
        ></v-text-field>
        <v-autocomplete
          :items="autocompleteItems"
          label="Response Template"
          clearable
          clear-icon="cancel"
          tabindex="3"
          no-data-text="Nothing match your search"
          item-text="name"
          item-value="id"
          dense
           class="custom-label text no-margin-bottom"
          v-on:change="templateSelected"
        ></v-autocomplete>
        <RichText tabindex="2" :data="message" :field="richField" v-on:update-item="updateMessage"></RichText>
      </v-flex>
      <v-card-actions class="px-4 pt-0 ma-0 pb-3">
        <v-flex grow pt-0>
          <v-btn class="mr-2" color="success">Send</v-btn>
          <v-btn icon @click="multipleAttachmentsDialog = true">
            <v-icon color="secondary">attach_file</v-icon>
          </v-btn>
          <v-dialog v-model="multipleAttachmentsDialog" max-width="1200">
                      <v-card class="pa-4">
                        <v-card-title class="pa-0 pb-2">
                          <h2>Select documents to attach</h2>
                        </v-card-title>
                        <v-card-text class="px-0 pt-0 pb-0">
                          <v-flex xs12>
                    <v-data-table
                        :headers="headers"
                        :items="docsTable"
                        class="doc-table attached"
                        select-all
                          v-model="selected"
                          :pagination.sync="pagination"
                            select-all
              item-key="name"
                      >
                      <template v-slot:headers="props">
                <tr>
                  <th >
                    <v-checkbox
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                      primary
                      hide-details
                      @click.stop="toggleAll"
                      color="secondary"
                    ></v-checkbox>
                  </th>
                  <th
class="text-xs-left px-0"
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                    @click="changeSort(header.value)"
                  >
                    <v-icon small>arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
               <td class="px-3 doc-check">
                  <v-checkbox
                    v-model="props.selected"
                    primary
                    hide-details
                     v-if="props.item.type !== 'folder'"
                    color="secondary"
                  ></v-checkbox>
                </td>
                <td class="doc-primary-td text-truncate">
                <v-flex v-if="props.item.type == 'folder'" >
                  <font-awesome-icon :style="{ color: 'orange' }" size="2x":icon="['fas', props.item.icon]" class="mr-3"></font-awesome-icon>
                  <v-tooltip right  color="secondary">
                   <template v-slot:activator="{ on }">
                    <font-awesome-icon v-on="on" v-if="props.item.locked== 'yes'"  size="xs"  icon="lock" class="mr-3 locked" :style="{ color: '#bf600f' }"></font-awesome-icon>
                     </template>
                      <span>System Folder: Can't be renamed or deleted</span>
                    </v-tooltip>
                  <h3 class="d-inline-block" ><a href="">{{ props.item.name }}</a></h3>
                </v-flex>
                <v-flex v-else>
                  <font-awesome-icon size="2x":icon="['far', props.item.icon]" class="secondary--text mr-3"></font-awesome-icon><h3 class="d-inline-block" ><a href="">{{ props.item.name }}</a></h3>
                </v-flex>
                </td>
                <td class="text-truncate">{{ props.item.date }}</td>
                <td class="text-truncate">{{ props.item.size }}</td>
                <td class="text-truncate">{{ props.item.modified }}</td>
              </template>
            </v-data-table>
            </v-flex>
              <v-flex class="pb-0">
                <h2>Selected documents</h2>
                <v-flex xs class="mt-2 selected-docs">
                  <v-flex class="p-relative mr-4  pr-2 mb-1" d-inline-block v-for="item in selected" :key="item.name">
                    <font-awesome-icon size="2x" :icon="['far', item.icon]" class="secondary--text mr-3"></font-awesome-icon><h3 class="d-inline-block" >{{ item.name }}</h3>
                    <v-btn icon @click="" class="remove-btn">
                      <v-icon color="error">cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </flex>
              </v-flex>
            </v-flex>
                        </v-card-text>
                        <v-card-actions class="ma-0 pa-0 pt-2">
                          <v-btn @click="" color="success">Attach Files</v-btn>
                          <v-btn @click="multipleAttachmentsDialog = false" color="secondary">Cancel</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>

          <!--<AttachmentsDialog
          :attachments="attachments"
          :allow-select-multiple="true"
          :currentCase="currentCase"
          :selectedAttachments="selectedAttachments"
          :user="user"/>
        <p v-if="this.selectedAttachments.length===0"></p>
        <p v-else>{{this.selectedAttachments.length}} attachments</p>-->
        </v-flex>
        <v-flex shrink>
          <v-tooltip left color="secondary">
            <v-btn
              slot="activator"
              class="ma-0 mt-0"
              icon
              @click="emailWindowToggled = !emailWindowToggled"
            >
              <v-icon color="secondary">delete</v-icon>
            </v-btn>
            <span>Discard Draft</span>
          </v-tooltip>
        </v-flex>
      </v-card-actions>
    </v-card>

     <!-- Case Page Components -->
       <!--
      <v-container fluid pt-0 px-0 ma-0>
        <v-layout justify-start column class="mb-4">

           <CaseEdit></CaseEdit>
          <CaseTasks></CaseTasks>
            <CaseTimeline></CaseTimeline>
              <CaseConversations></CaseConversations>
              <EmailWindow></EmailWindow>
          <CaseNotifications></CaseNotifications>
              <CaseNotes></CaseNotes>
              <CaseDocuments></CaseDocuments>
        </v-layout>
      </v-container>
        -->

   <!--
    <v-container fluid pa-0 ma-0>
      <v-layout justify-start column class="mb-4 pb-4">
         <CaseTemplateOverview></CaseTemplateOverview>
        </v-layout>
    </v-container>
    -->

    <!--
    <v-container fluid pa-0 ma-0>
      <v-layout justify-start column class="mb-4 pb-4">
          <MetricsOverview></MetricsOverview>
        </v-layout>
    </v-container>
    -->
    <!--
    <v-container fluid pa-0 ma-0>
      <v-layout justify-start column class="mb-4 pb-4">
          <MetricsDashboard></MetricsDashboard>
        </v-layout>
    </v-container>
    -->

    <!--
    <v-container fluid pa-0>
      <v-layout justify-start column class="mb-4 pb-4">
        <CaseConfigOverview></CaseConfigOverview>
      </v-layout>
    </v-container>
    -->

    <!--
    <DashboardOverview></DashboardOverview>
    -->
    <!--
    <Teams></Teams>
    -->

    <!--
    <Users></Users>
    -->

    <!--
    <div id="users-main">
      <PageHeader title="Users" subtitle="Administering Users"></PageHeader>
      <V-flex px-4 pt-3>
        <CardContainer
            :newItemPath="newItemPath"
            itemLabel="User"
            title="Users"
            itemtype="UserCard"
            :isLoading="isLoading"
            :searchableBy="searchByOptions"
            :sortableBy="orderByOptions"
            :itemList="userList"
        ></CardContainer>
      </V-flex>
    </div>
    -->

    <!-- User Edit -->
    <!--
    <v-container fluid px-0 pb-4 pt-0 ma-0>
      <v-layout justify-start column class="mb-4">
        <div id="user edit details">
          <user-edit :user="currentUser"></user-edit>
        </div>
      </v-layout>
    </v-container>
    -->

      <!-- Teams Container -->
      <!--
      <div id="teams-main">
        <V-flex px-4>
          <CardContainer
            itemtype="TeamCard"
            :isLoading="isLoading"
            :searchableBy="searchByOptions"
            :sortableBy="orderByOptions"
            :itemList="teamsList"
          ></CardContainer>
        </V-flex>
      </div>
      -->

      <!-- Teams Edit -->
      <!--
      <v-container fluid px-0 pb-4 pt-0 ma-0>
        <v-layout justify-start column class="mb-4">
          <div id="user edit details">
            <team-edit></team-edit>
          </div>
        </v-layout>
      </v-container>
      -->

      <!-- Buckets Overview -->
      <!--
       <v-container fluid px-0 pb-4 pt-0 ma-0>
        <v-layout justify-start column class="mb-4">
          <div id="buckets">
            <buckets></buckets>
          </div>
        </v-layout>
      </v-container>
      -->

      <!-- Bucket Group Overview -->
      <!--
     <v-layout justify-start column class="mb-4">
        <div id="bucket-group">
          <bucketGroup></bucketGroup>
        </div>
      </v-layout>
      -->

       <!-- Import -->
      <!--
      <v-container fluid px-0 pb-4 pt-0 ma-0>
        <v-layout justify-start column class="mb-4">
          <div id="import">
            <ImportWizard></ImportWizard>
          </div>
        </v-layout>
      </v-container>
      -->
       <!-- Account config -->
      <!--
       <v-container fluid px-0 pb-4 pt-0 ma-0>
        <v-layout justify-start column class="mb-4">
          <div id="all-accounts">
            <AccountConfig></AccountConfig>
          </div>
        </v-layout>
      </v-container>
      -->
      <!-- All Accounts-->
      <!--
      <v-container fluid px-0 pb-4 pt-0 ma-0>
        <v-layout justify-start column class="mb-4">
          <div id="all-accounts">
            <AllAccounts></AllAccounts>
          </div>
        </v-layout>
      </v-container>
      -->
      <!-- New Accounts-->
      <!--
      <v-container fluid px-0 pb-4 pt-0 ma-0>
        <v-layout justify-start column class="mb-4">
          <div id="new-account">
            <NewAccount></NewAccount>
          </div>
        </v-layout>
      </v-container>
      -->
      <!-- Jobs -->
     <!--
       <v-container fluid px-0 pb-4 pt-0 ma-0>
        <v-layout justify-start column class="mb-4">
          <div id="jobs">
            <Jobs></Jobs>
          </div>
        </v-layout>
      </v-container>
      -->
      <!-- Jobs Scheduler-->
      <!--
      <v-container fluid px-0 pb-4 pt-0 ma-0>
        <v-layout justify-start column class="mb-4">
          <div id="jobs-scheduler">
            <JobsScheduler></JobsScheduler>
          </div>
        </v-layout>
      </v-container>
      -->
      <!-- Service Level-->
       <!--
       <v-container fluid px-0 pb-4 pt-0 ma-0>
        <v-layout justify-start column class="mb-4">
          <div id="service-level">
            <ServiceLevels></ServiceLevels>
          </div>
        </v-layout>
      </v-container>
      -->
      <!-- Comms Inbox -->
      <!--
      <v-container fluid px-0 pb-4 pt-0 ma-0>
        <v-layout justify-start column class="mb-4">
          <div id="search">
            <CommsInbox></CommsInbox>
          </div>
        </v-layout>
      </v-container>
    -->
      <!-- snackbar
      <v-flex xs12 mb-4 pa-4>
        <div class="caption opacity-54 mb-1 text-uppercase primary--text">
          <PageTitle pageTitle="Snackbar - Page update message component"></PageTitle>
        </div>
        <v-divider class="mb-3"></v-divider>
        <Snackbar></Snackbar>
      </v-flex>
-->
      <!-- Search Results page -->
      <!--
      <v-container fluid px-0 pb-4 pt-0 ma-0>
        <v-layout justify-start column class="mb-4">
          <div id="search-results">
            <SearchResults :dataProvider="bucketProvider"></SearchResults>
          </div>
        </v-layout>
      </v-container>
       -->
      <!--
      <v-container fluid px-0 pb-4 pt-0 ma-0>
        <v-layout justify-start column class="mb-4">
          <div id="search-focus">
            <SearchFocused :dataProvider="bucketProvider"></SearchFocused>
          </div>
        </v-layout>
      </v-container>
      -->
      <!-- Notifications page -->
      <!--
      <v-container fluid px-0 pb-4 pt-0 ma-0>
        <v-layout justify-start column class="mb-4">
          <div id="notifications">
            <Notifications></Notifications>
          </div>
        </v-layout>
      </v-container>
      -->
      <!-- Bucket Group New View -->
      <!--
      <v-container fluid pa-0>
        <v-layout justify-start column class="mb-4">
          <div id="bucket_group_new_details">
            <BucketGroupNew></BucketGroupNew>
          </div>
        </v-layout>
      </v-container>
      -->
      <!-- Bucket Group Edit View -->
      <!--
      <v-container fluid pa-0>
        <v-layout justify-start column class="mb-4">
          <div id="bucket_grou_edit_details">
            <BucketGroupEdit></BucketGroupEdit>
          </div>
        </v-layout>
      </v-container>
      -->
      <!-- Bucket New View -->
      <!--
      <v-container fluid pa-0>
        <v-layout justify-start column class="mb-4">
          <div id="bucket_new_details">
            <BucketNew></BucketNew>
          </div>
        </v-layout>
      </v-container>
      -->
      <!-- Bucket Edit View -->
       <!--
      <v-container fluid pa-0>
        <v-layout justify-start column class="mb-4">
          <div id="bucket_edit_details">
            <BucketEdit></BucketEdit>
          </div>
        </v-layout>
      </v-container>
      -->
      <!-- BucketView Component -->
      <!--
      <v-container fluid pa-0 ma-0>
        <v-layout justify-start column class="mb-4">
          <bucket-view :dataProvider="bucketProvider" :dataSearcher="bucketProvider"></bucket-view>
        </v-layout>
      </v-container>
      -->
      <!-- Configure Case -->
     <!--
     <v-container fluid ma-0 pa-0 px-4>
      <div class="fixed-header" :class="{'mobile': $vuetify.breakpoint.smAndDown}">
        <v-layout  align-center fill-height class="fixed-header-wrapper">
          <v-flex shrink class="text-truncate" pr-4>
            <v-tooltip color="secondary" bottom>
              <template v-slot:activator="{ on }">
                <h2 v-on="on" class="p-relative text-truncate" >
                  Configure Benefits
                </h2>
              </template>
                <span>Configure Benefits</span>
              </v-tooltip>
            <h4 class="pt-1 sub-header ">Case Templates</h4>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </div>
      </v-container>
    <v-container fluid ma-0 pt-0 pt-4>
        <v-layout justify-start column class="mb-4">
          <div id="user edit details">
            <CaseConfig :caseType="caseConfigCaseType"></CaseConfig>
          </div>
        </v-layout>
      </v-container>
      -->
      <!-- Page Header -->
      <!--
      <PageHeader></PageHeader>
      -->
      <!-- Case page layout with fixed sidebar right -->
      <!--
      <v-container fluid class="px-3 pb-3 ma-0 pt-0">
        <v-layout row wrap mb-4>
          <v-flex sm12 md9 px-0>
            <v-flex xs12 px-2 mb-3 id="test-link0">
              <v-flex px-4 py-4 class="elevation-2 rounded-3" style="background-color:white;">
                <v-container>
                  <h2 class="mb-4">Case Elements</h2>
                  <v-flex xs12 mb-4 pb-4>
                    <div class="caption opacity-54 mb-1 text-uppercase primary--text">
                      <PageTitle pageTitle="Task Buttons"></PageTitle>
                    </div>
                    <v-divider class="mb-3"></v-divider>
                    <v-btn color="secondary" class="mb-2 mr-3 ml-0">
                      <v-icon class="mr-2">done_all</v-icon>Task name
                    </v-btn>
                    <v-btn color="secondary" class="mb-2 mr-3 ml-0">
                      <v-icon class="mr-2">done_all</v-icon>Task name
                    </v-btn>
                    <v-btn color="secondary" class="mb-2 mr-3 ml-0">
                      <v-icon class="mr-2">done_all</v-icon>Task name
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 mb-4 pb-4>
                    <div class="caption opacity-54 mb-1 text-uppercase primary--text">
                      <PageTitle pageTitle="Rich Text"></PageTitle>
                    </div>
                    <v-divider class="mb-3"></v-divider>
                    <RichText :field="fieldData.richTextField" :data="fieldData.richTextData"></RichText>
                  </v-flex>
                  <v-flex xs12 mb-4 pb-4>
                    <div class="caption opacity-54 mb-1 text-uppercase primary--text">
                      <PageTitle pageTitle="Text Input"></PageTitle>
                    </div>
                    <v-divider class="mb-3"></v-divider>
                    <TextField :field="fieldData.textInputField" :data="fieldData.textInputData"></TextField>
                  </v-flex>
                  <v-flex xs12 mb-4>
                    <div class="caption opacity-54 mb-1 text-uppercase primary--text">
                      <PageTitle pageTitle="Text Area"></PageTitle>
                    </div>
                    <v-divider class="mb-3"></v-divider>
                    <TextArea :field="fieldData.textAreaField" :data="fieldData.textAreaData"></TextArea>
                  </v-flex>
                  <v-flex xs12 mb-4>
                    <div class="caption opacity-54 mb-1 text-uppercase primary--text">
                      <PageTitle pageTitle="Currency Field"></PageTitle>
                    </div>
                    <v-divider class="mb-3"></v-divider>
                    <CurrencyField :field="fieldData.currencyField" :data="fieldData.currencyData"></CurrencyField>
                  </v-flex>
                  <v-flex xs12 mb-4>
                    <div class="caption opacity-54 mb-1 text-uppercase primary--text">
                      <PageTitle pageTitle="Number Field"></PageTitle>
                    </div>
                    <v-divider class="mb-3"></v-divider>
                    <NumberField :field="fieldData.numberField" :data="fieldData.numberData"></NumberField>
                  </v-flex>
                  <v-flex xs12 mb-4>
                    <div class="caption opacity-54 mb-1 text-uppercase primary--text">
                      <PageTitle pageTitle="Checkbox"></PageTitle>
                    </div>
                    <v-divider class="mb-3"></v-divider>
                    <CheckBox :field="fieldData.checkboxField" :data="fieldData.checkboxData"></CheckBox>
                  </v-flex>
                  <v-flex xs12 mb-4>
                    <div class="caption opacity-54 mb-1 text-uppercase primary--text">
                      <PageTitle pageTitle="Select Field"></PageTitle>
                    </div>
                    <v-divider class="mb-3"></v-divider>
                    <SelectField :field="fieldData.selectField" :data="fieldData.selectData"></SelectField>
                  </v-flex>
                  <v-flex xs12 mb-4>
                    <div class="caption opacity-54 mb-1 text-uppercase primary--text">
                      <PageTitle pageTitle="Select Field Mutliple Options"></PageTitle>
                    </div>
                    <v-divider class="mb-3"></v-divider>
                    <SelectFieldMultiple></SelectFieldMultiple>
                  </v-flex>
                  <v-flex xs12 mb-4>
                    <div class="caption opacity-54 mb-1 text-uppercase primary--text">
                      <PageTitle pageTitle="Select Field Mutliple Chips"></PageTitle>
                    </div>
                    <v-divider class="mb-3"></v-divider>
                    <SelectFieldMultipleChips></SelectFieldMultipleChips>
                  </v-flex>
                  <v-flex xs12 mb-4>
                    <div class="caption opacity-54 mb-1 text-uppercase primary--text">
                      <PageTitle pageTitle="Boolean Field"></PageTitle>
                    </div>
                    <v-divider class="mb-3"></v-divider>
                    <BooleanField :field="fieldData.booleanField" :data="fieldData.booleanData"></BooleanField>
                  </v-flex>
                  <v-flex xs12 mb-4>
                    <div class="caption opacity-54 mb-1 text-uppercase primary--text">
                      <PageTitle pageTitle="Address Field"></PageTitle>
                    </div>
                    <v-divider class="mb-3"></v-divider>
                    <AddressField :field="fieldData.addressField" :data="fieldData.addressData"></AddressField>
                  </v-flex>
                  <v-flex xs12 mb-4>
                    <div class="caption opacity-54 mb-1 text-uppercase primary--text">
                      <PageTitle pageTitle="Date Field"></PageTitle>
                    </div>
                    <v-divider class="mb-3"></v-divider>
                    <DateField :field="fieldData.dateField" :data="fieldData.dateData"></DateField>
                  </v-flex>
                  <v-flex xs12 mb-4>
                    <div class="caption opacity-54 mb-1 text-uppercase primary--text">
                      <PageTitle pageTitle="Relation Field"></PageTitle>
                    </div>
                    <v-divider class="mb-3"></v-divider>
                    <RelationField :field="fieldData.relationField" :data="fieldData.relationData"></RelationField>
                  </v-flex>
                  <v-flex xs12 mb-4>
                    <div class="caption opacity-54 mb-1 text-uppercase primary--text">
                      <PageTitle pageTitle="Image Viewer"></PageTitle>
                    </div>
                    <v-divider class="mb-3"></v-divider>
                    <ImageViewer></ImageViewer>
                  </v-flex>
                  <v-flex xs12 mb-4>
                    <div class="caption opacity-54 mb-1 text-uppercase primary--text">
                      <PageTitle pageTitle="Document Field"></PageTitle>
                    </div>
                    <v-divider class="mb-3"></v-divider>
                    <DocumentField :field="fieldData.documentField" :data="fieldData.documentData"></DocumentField>
                  </v-flex>
                  <v-flex xs12 mb-4>
                    <div class="caption opacity-54 mb-1 text-uppercase primary--text">
                      <PageTitle pageTitle="Embedded Table"></PageTitle>
                    </div>
                    <v-divider class="mb-3"></v-divider>
                    <EmbeddedTable
                      :field="fieldData.embeddedTableField"
                      :data="fieldData.embeddedTableData"
                    ></EmbeddedTable>
                  </v-flex>
                </v-container>
              </v-flex>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs12 lg6 px-2 mb-3 id="test-link2">
                <v-flex px-4 py-4 class="elevation-2 rounded-3" style="background-color:white;">
                  <v-container>
                    <h2>Text Inputs</h2>
                    <v-layout mt-4 wrap>
                      <v-flex xs12>
                        <v-text-field
                          box
                          class="primary--text"
                          color="secondary"
                          label="Standard text input"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          box
                          class="primary--text"
                          color="secondary"
                          label="Standard text input disabled"
                          value="Lorem ipsum"
                          disabled
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          box
                          class="primary--text"
                          color="secondary"
                          label="Text input with hint and value set"
                          value="Lorem ipsum"
                          hint="Put in the claim id here"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          box
                          :rules="[rules.required]"
                          label="Input with character limit and also clearable"
                          clear-icon="cancel"
                          counter
                          clearable
                          maxlength="20"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          box
                          :rules="[rules.required, rules.email]"
                          label="E-mail with format validation"
                        ></v-text-field>
                      </v-flex>
                      <v-flex>
                        <v-text-field box label="Input with Prefix for $" value="10.00" prefix="$"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          box
                          label="Input with suffix for lbs"
                          value="28.00"
                          suffix="lbs"
                        ></v-text-field>
                      </v-flex>
                      <v-flex>
                        <v-text-field box label="Input with Prefix for $" value="10.00" prefix="$"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          box
                          label="Input with suffix for lbs"
                          value="28.00"
                          suffix="lbs"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field box label="Input with prepended icon" prepend-icon="place"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field box label="Input with appended icon" append-icon="place"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field box label="Input with prepended icon" prepend-icon="place"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field box label="Input with appended icon" append-icon="place"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          box
                          label="Input with appended outer icon"
                          append-outer-icon="place"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea box label="Text Area"></v-textarea>
                      </v-flex>
                      <v-flex xs12>
                        <v-autocomplete
                          :items="autocompleteItems"
                          box
                          label="Searchable select field label"
                          persistent-hint
                          hint="Hint: Start typing to filter options"
                          no-data-text="No results"
                          append-icon="keyboard_arrow_down"
                          dense
                        ></v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-flex>

              <v-flex xs12 lg6 px-2 mb-3 id="test-link3">
                <v-flex
                  fill-height
                  px-4
                  py-4
                  class="elevation-2 rounded-3"
                  style="background-color:white;"
                >
                  <v-container>
                    <h2>Other Elements</h2>
                    <v-layout mt-4 wrap>
                      <v-flex xs12>
                        <edit-code-pane ref="myCm" :code="codeValue" language="json" v-on:update-code="updateCodeValue"></edit-code-pane>
                      </v-flex>
                      <v-flex>
                        <v-checkbox color="secondary" label="Checkbox label" v-model="checkbox"></v-checkbox>
                      </v-flex>
                      <v-flex xs12>
                        <v-radio-group v-model="radios" column>
                          <v-radio color="secondary" label="Radio One" value="1"></v-radio>
                          <v-radio color="secondary" label="Radio Two" value="2"></v-radio>
                          <v-radio color="secondary" label="Radio Three" value="3"></v-radio>
                          <v-radio color="secondary" label="Radio Four" value="4"></v-radio>
                        </v-radio-group>
                        <v-switch color="secondary" label="Switch Label" v-model="switch1"></v-switch>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs12 lg4 px-2 mb-3 id="test-link4">
                <v-flex
                  px-4
                  py-4
                  fill-height
                  class="elevation-2 rounded-3"
                  style="background-color:white;"
                >
                  <v-container>
                    <h2>Buttons</h2>
                    <v-layout mt-4 wrap>
                      <v-flex xs12>
                        <v-btn class="ml-0" color="success">Primary</v-btn>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn class="ml-0" color="secondary">Secondary</v-btn>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn class="ml-0" color="error">Error Button</v-btn>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn outline class="ml-0" color="primary">Outline Button</v-btn>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn class="ml-0" color="primary" flat>Flat CTA Button</v-btn>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn class="ml-0" color="error" flat>Flat Error Button</v-btn>
                      </v-flex>
                      <v-flex xs12 sm3>
                        <v-btn flat icon color="pink">
                          <v-icon>favorite</v-icon>
                        </v-btn>
                      </v-flex>

                      <v-flex xs12 sm3>
                        <v-btn flat icon color="indigo">
                          <v-icon>star</v-icon>
                        </v-btn>
                      </v-flex>

                      <v-flex xs12 sm3>
                        <v-btn flat icon color="green">
                          <v-icon>cached</v-icon>
                        </v-btn>
                      </v-flex>

                      <v-flex xs12 sm3>
                        <v-btn flat icon color="deep-orange">
                          <v-icon>thumb_up</v-icon>
                        </v-btn>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn color="secondary" class="ml-0 white--text">
                          w/ icon
                          <v-icon right dark>cloud_upload</v-icon>
                        </v-btn>
                        <v-btn color="secondary" class="ml-0 white--text">
                          <v-icon left class="mr-2" dark>search</v-icon>w/ icon
                        </v-btn>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn block class="ml-0" color="success">Full Width</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-flex>
              <v-flex d-flex xs12 lg4 px-2 mb-3 id="test-link5">
                <v-flex
                  px-4
                  py-4
                  fill-height
                  class="elevation-2 rounded-3"
                  style="background-color:white;"
                >
                  <v-container>
                    <h2>UI Elements</h2>
                    <v-layout mt-4 wrap>
                      <v-flex xs>
                        <v-btn
                          class="ml-0"
                          @click="dialog2 = true"
                          dark
                          color="secondary"
                        >Open Dialog</v-btn>
                        <v-dialog v-model="dialog2" max-width="290">
                          <v-card class="pa-4">
                            <v-card-title class="ma-0 mb-2 pa-0">
                              <h2>Dialog. Tada.</h2>
                            </v-card-title>
                            <v-card-text
                              class="ma-0 mt-2 mb-1 pa-0"
                            >Lorem ipsum dolor sit amet consectetur adit piscing.</v-card-text>
                            <v-card-actions class="ma-0 mt-3 pa-0">
                              <v-btn color="success">Confirm</v-btn>
                              <v-spacer></v-spacer>
                              <v-btn @click="dialog2 = false" color="error" flat>Cancel</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-flex>
                      <v-flex xs12 py-4>
                        <v-tooltip bottom color="secondary">
                          <span slot="activator">This text has a tooltip</span>
                          <span>Tooltip</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-flex>
              <v-flex xs12 lg4 px-2 mb-3 id="test-link6">
                <v-flex
                  px-4
                  py-4
                  fill-height
                  class="elevation-2 rounded-3"
                  style="background-color:white;"
                >
                  <v-container>
                    <h2>Section Six</h2>
                    <v-layout mt-4 wrap>
                      <v-flex xs>...</v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex md3 px-2 mb-0 style="position: relative;" class="hidden-sm-and-down">
            <v-flex xs12 px-0 class="rounded-3">
              <div class="caption opacity-54 mb-1 text-uppercase primary--text">
                <PageTitle pageTitle="Jump to a section"></PageTitle>
              </div>
              <v-divider class="mb-0"></v-divider>
            </v-flex>
            <v-navigation-drawer
              absolute
              style="position:sticky; height:auto !important; background:none !important;"
              floating
              right
              persistent
              permanent
              class="pb-3"
            >
              <v-list dense class="pa-0 ma-0">
                <v-list-tile @click="$vuetify.goTo('#test-link0', goToOptions)">Case Elements</v-list-tile>
                <v-divider></v-divider>
                <v-list-tile @click="$vuetify.goTo('#test-link2', goToOptions)">Text Input Fields</v-list-tile>
                <v-divider></v-divider>
                <v-list-tile @click="$vuetify.goTo('#test-link3', goToOptions)">Other Elements</v-list-tile>
                <v-divider></v-divider>
                <v-list-tile @click="$vuetify.goTo('#test-link4', goToOptions)">Buttons</v-list-tile>
                <v-divider></v-divider>
                <v-list-tile @click="$vuetify.goTo('#test-link5', goToOptions)">UI Elements</v-list-tile>
                <v-divider></v-divider>
                <v-list-tile @click="$vuetify.goTo('#test-link6', goToOptions)">Section Six</v-list-tile>
                <v-divider></v-divider>
              </v-list>
              <v-btn color="success" class="mt-2" block>Save changes</v-btn>
              <v-btn color="error" class="mb-0" block>Cancel</v-btn>
            </v-navigation-drawer>
          </v-flex>
          <v-flex class="hidden-md-and-up" ma-0>
            <v-btn color="success">Save changes</v-btn>
            <v-btn color="error">Cancel</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      -->
        <TasksTable></TasksTable>
      <!-- Users on CardContainer -->
      <!--
      <v-container fluid pa-2>
        <v-layout row wrap>
          <v-flex xs12 px-3>
            <div class="caption opacity-54 mb-1 text-uppercase primary--text">
              <PageTitle pageTitle="Users"></PageTitle>
            </div>
            <v-divider class="mb-3"></v-divider>
          </v-flex>
          <v-flex xs12 px-2>
            <div id="users-main">
              <CardContainer
                :newItemPath="newItemPath"
                itemLabel="List of Users"
                itemtype="UserCard"
                :isLoading="isLoading"
                :searchableBy="searchByOptions"
                :sortableBy="orderByOptions"
                :itemList="users"
              ></CardContainer>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      -->
      <!-- Page Structure Options -->
      <!--
      <v-container fluid pa-3>
        <v-layout row wrap>
          <v-flex xs12 px-2 class="rounded-3">
            <div class="caption opacity-54 mb-1 text-uppercase primary--text">
              <PageTitle pageTitle="Grids"></PageTitle>
            </div>
            <v-divider class="mb-3"></v-divider>
          </v-flex>

          <v-flex xs12 md4 px-2 mb-3>
            <v-card dark color="primary">
              <v-card-text>xs12 md4 px-2</v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 md4 px-2 mb-3>
            <v-card dark color="secondary">
              <v-card-text>xs12 md4 px-2</v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 md4 px-2 mb-3>
            <v-card dark color="accent">
              <v-card-text>xs12 md4 px-2</v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 md6 px-2 mb-3>
            <v-card dark color="primary">
              <v-card-text>xs12 md6 px-2</v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 md6 px-2 mb-3>
            <v-card dark color="secondary">
              <v-card-text>xs12 md6 px-2</v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 px-2 mb-3>
            <v-card dark color="primary">
              <v-card-text>xs12 px-2</v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 px-2 mb-3>
            <v-btn class="ma-0" @click="dialog = true" dark color="primary">Open Dialog</v-btn>
            <v-dialog v-model="dialog" max-width="290">
              <v-card class="pa-4">
                <v-card-title class="pa-0">
                  <h2>Dialog. Tada.</h2>
                </v-card-title>

                <v-card-text class="pa-0">Lorem ipsum dolor sit amet consectetur adit piscing.</v-card-text>
              </v-card>
            </v-dialog>
          </v-flex>
        </v-layout>
      </v-container>
      -->
      <!-- Alerts -->
      <!--
      <v-container fluid pa-3>
        <v-layout row wrap>
          <v-flex xs12 px-2 class="rounded-3">
            <div class="caption opacity-54 mb-1 text-uppercase primary--text">
              <PageTitle pageTitle="Alerts"></PageTitle>
            </div>
            <v-divider class="mb-3"></v-divider>
          </v-flex>

          <v-flex xs12 px-2 mb-3>
            <v-alert :value="true" type="success" dismissible class="mb-3">This is a success alert.</v-alert>

            <v-alert :value="true" type="info" dismissible class="mb-3">This is a info alert.</v-alert>

            <v-alert :value="true" type="warning" dismissible class="mb-3">This is a warning alert.</v-alert>

            <v-alert :value="true" type="error" dismissible class="mb-3">This is an error alert.</v-alert>
          </v-flex>
        </v-layout>
      </v-container>
      -->
      <!-- Login component -->
      <!--
      <v-container pa-3 fluid>
        <v-layout row wrap>
          <v-flex xs12 px-2 class="rounded-3">
            <div class="caption opacity-54 mb-1 text-uppercase primary--text">
              <PageTitle pageTitle="Login Component"></PageTitle>
            </div>
            <v-divider class="mb-2"></v-divider>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid pa-0 ma-0>
        <v-layout justify-start column class="mb-4">
          <div id="user edit details">
            <Login></Login>
          </div>
        </v-layout>
      </v-container>
      <v-spacer class="mb-3"></v-spacer>
      -->

      <!-- Forgot password component -->
      <!--
      <v-container fluid pa-3>
        <v-layout row wrap>
          <v-flex xs12 px-2 class="rounded-3">
            <div class="caption opacity-54 mb-1 text-uppercase primary--text">
              <PageTitle pageTitle="Forgotten Password"></PageTitle>
            </div>
            <v-divider class="mb-2"></v-divider>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid pa-0 ma-0>
        <v-layout justify-start column class="mb-4">
          <div id="user edit details">
            <ForgotPassword></ForgotPassword>
          </div>
        </v-layout>
      </v-container>
      -->
      <!-- Password Reset Confirmation component -->
      <!--
      <v-container fluid pa-3>
        <v-layout row wrap>
          <v-flex xs12 px-2 class="rounded-3">
            <div class="caption opacity-54 mb-1 text-uppercase primary--text">
              <PageTitle pageTitle="Password Reset Confirmation"></PageTitle>
            </div>
            <v-divider class="mb-2"></v-divider>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container fluid pa-0 ma-0>
        <v-layout justify-start column class="mb-4">
          <div id="user edit details">
            <ResetConfirmation></ResetConfirmation>
          </div>
        </v-layout>
      </v-container>
      -->
      <!-- Password Password component -->
      <!--
      <v-container fluid pa-3>
        <v-layout row wrap>
          <v-flex xs12 px-2 class="rounded-3">
            <div class="caption opacity-54 mb-1 text-uppercase primary--text">
              <PageTitle pageTitle="Reset Password"></PageTitle>
            </div>
            <v-divider class="mb-2"></v-divider>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container fluid pa-0 ma-0>
        <v-layout justify-start column class="mb-4">
          <div id="user edit details">
            <ResetPassword></ResetPassword>
          </div>
        </v-layout>
      </v-container>
      -->
      <!-- Password Password component -->
      <!--
      <v-container fluid pa-3>
        <v-layout row wrap>
          <v-flex xs12 px-2 class="rounded-3">
            <div class="caption opacity-54 mb-1 text-uppercase primary--text">
              <PageTitle pageTitle="Custom Domain"></PageTitle>
            </div>
            <v-divider class="mb-2"></v-divider>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container fluid pa-0 ma-0>
        <v-layout justify-start column class="mb-4">
          <div id="user edit details">
            <CustomDomain></CustomDomain>
          </div>
        </v-layout>
      </v-container>
      <v-spacer class="mb-3"></v-spacer>
      <v-container fluid pa-0 ma-0>
        <v-layout justify-start column class="mb-4">
          <PresencePanel caseId="123" :currentUser="currentUser" :currentViewers="currentViewers"></PresencePanel>
        </v-layout>
      </v-container>
      -->
      <metrics-dashboard></metrics-dashboard>
      </v-flex>
    </v-content>
  </v-layout>
</template>

<script>
import { mapState } from "vuex"
import PageTitle from "@/components/PageTitle.vue"
import CardContainer from "@/components/CardContainer.vue"
import UserEdit from "@/components/Users/UserEdit/UserEdit.vue"
import TeamEdit from "@/components/teams/TeamEdit.vue"
import CaseConfig from "@/components/cases/case-config/CaseConfig.vue"
import CaseEdit from "@/components/cases/case-edit/CaseEdit.vue"
import CaseDocuments from "@/components/cases/case-edit/CaseDocuments.vue"
import CaseTimeline from "@/components/cases/case-edit/CaseTimeline.vue"
import CaseNotes from "@/components/cases/case-edit/CaseNotes.vue"
import CaseNotifications from "@/components/cases/case-edit/CaseNotifications.vue"
import CaseConversations from "@/components/cases/case-edit/CaseConversations.vue"
import CaseTasks from "@/components/cases/case-edit/CaseTasks.vue"
import CaseConfigOverview from "@/components/cases/case-config/CaseConfigOverview.vue"
import CaseTemplateOverview from "@/components/case-templates/CaseTemplateOverview.vue"
import DashboardOverview from '@/components/DashboardOverview'
import Login from "@/components/Login.vue"
import ForgotPassword from "@/components/ForgotPassword.vue"
import ResetConfirmation from "@/components/ResetConfirmation.vue"
import ResetPassword from "@/components/ResetPassword.vue"
import CustomDomain from "@/components/CustomDomain.vue"
import MainMenu from "@/components/navigation/MainMenu.vue"
import InCaseMenu from "@/components/navigation/InCaseMenu.vue"
import Logo from "@/components/Logo.vue"
import Fixtures from "./fixtures.js"
import CurrentUser from "./currentUserFixtures.js"
import AccountFAB from "@/components/AccountFAB.vue"
import GlobalFAB from "@/components/GlobalFAB.vue"
import PageHeader from "@/components/PageHeader.vue"
import Buckets from "@/components/buckets/bucket-edit/Buckets.vue"
import BucketGroup from "@/components/buckets/bucket-edit/BucketGroup.vue"
import BucketView from "@/components/buckets/BucketView.vue"
import MockDataProvider from "@/components/buckets/bucket-providers/BucketDataMocker.js"
import RichText from "@/components/cases/case-elements/RichText.vue"
import TextField from "@/components/cases/case-elements/TextField.vue"
import CurrencyField from "@/components/cases/case-elements/CurrencyField.vue"
import NumberField from "@/components/cases/case-elements/NumberField.vue"
import TextArea from "@/components/cases/case-elements/TextArea.vue"
import CheckBox from "@/components/cases/case-elements/CheckBox.vue"
import SelectField from "@/components/cases/case-elements/SelectField.vue"
import SelectFieldMultiple from "@/components/cases/case-elements/SelectFieldMultiple.vue"
import SelectFieldMultipleChips from "@/components/cases/case-elements/SelectFieldMultipleChips.vue"
import BooleanField from "@/components/cases/case-elements/BooleanField.vue"
import AddressField from "@/components/cases/case-elements/AddressField.vue"
import DateField from "@/components/cases/case-elements/DateField.vue"
import RelationField from "@/components/cases/case-elements/RelationField.vue"
import DocumentField from "@/components/cases/case-elements/DocumentField.vue"
import EmbeddedTable from "@/components/cases/case-elements/EmbeddedTable.vue"
import ImageViewer from "@/components/cases/case-elements/ImageViewer.vue"
import BucketNew from "@/components/buckets/bucket-edit/BucketNew.vue"
import BucketEdit from "@/components/buckets/bucket-edit/BucketEdit.vue"
import Notifications from "@/components/notifications/Notifications.vue"
// import PresencePanel from "@/scan-gui/components/PresencePanel.vue"
import SearchBar from "@/components/search/SearchBar.vue"
import SearchResults from "@/components/search/SearchResults.vue"
import CommsInbox from "@/components/comms/CommsInbox.vue"
import Snackbar from "@/components/snackbar/snackbar.vue"
import BucketGroupEdit from "@/components/buckets/bucket-edit/BucketGroupEdit.vue"
import Jobs from "@/components/jobs/Jobs.vue"
import JobsScheduler from "@/components/jobs/JobsScheduler.vue"
import TasksTable from "@/components/homepage/TasksTable.vue"
import ServiceLevels from "@/components/service-level/ServiceLevels.vue"
import AllAccounts from "@/components/accounts/AllAccounts.vue"
import NewAccount from "@/components/accounts/NewAccount.vue"
import AccountConfig from "@/components/accounts/account-config/AccountConfig.vue"
import EditCodePane from '@/components/shared/editCodePane.vue'
import ImportWizard from "@/components/import/importWizard.vue"
import Users from "@/components/Users/Users.vue"
import Teams from "@/components/teams/Teams.vue"
import EmailWindow from "@/components/comms/EmailWindow.vue"
import MetricsOverview from "@/components/metrics/MetricsOverview.vue"
import MetricsDashboard from "@/components/metrics/MetricsDashboard.vue"
import MessageSidePanel from "@/components/comms/MessageSidePanel.vue"
import CaseDocumentSidePanel from "@/components/cases/case-edit/CaseDocumentSidePanel.vue"

export default {
  name: "KitchenSink",
  data: () => ({
    multipleAttachmentsDialog: false,
    pagination: {
      sortBy: 'name'
    },
    selected: [],
    headers: [
      {
        text: 'Name',
        value: 'name'

      },
      { text: 'Date added', value: 'date' },
      { text: 'Size', value: 'size' },
      { text: 'Uploaded by', value: 'modified' }
    ],
    docsTable: [
      {
        name: 'A Folder name',
        date: 'April 24, 2021',
        size: '1',
        modified: 'System Folder - Locked',
        icon: 'folder',
        type: 'folder',
        locked: 'yes'
      },
      {
        name: 'A Folder name',
        date: 'April 24, 2021',
        size: '1',
        modified: 'Jonathan Bean',
        icon: 'folder',
        type: 'folder',
        locked: 'no'
      },
      {
        name: 'Generic file name',
        date: 'April 24, 2021',
        size: '156kb',
        modified: 'Jonathan Bean',
        icon: 'file',
        type: 'file'
      },
      {
        name: 'Word doc name',
        date: 'April 24, 2021',
        size: '156kb',
        modified: 'Jonathan Bean',
        icon: 'file-word',
        type: 'file'
      },
      {
        name: 'File image name',
        date: 'April 24, 2021',
        size: '356kb',
        modified: 'Jonathan Bean',
        icon: 'file-image',
        type: 'file'
      },
      {
        name: 'File excel name',
        date: 'April 24, 2021',
        size: '356kb',
        modified: 'Jonathan Bean',
        icon: 'file-excel',
        type: 'file'
      },
      {
        name: 'File html name',
        date: 'April 21, 2021',
        size: '356kb',
        modified: 'James Bean',
        icon: 'file-code',
        type: 'file'
      },
      {
        name: 'File pdf name',
        date: 'April 21, 2021',
        size: '356kb',
        modified: 'James Bean',
        icon: 'file-pdf',
        type: 'file'
      },
      {
        name: 'File powerpoint name',
        date: 'April 21, 2021',
        size: '356kb',
        modified: 'James Bean',
        icon: 'file-powerpoint',
        type: 'file'
      },
      {
        name: 'File zip name',
        date: 'April 21, 2021',
        size: '356kb',
        modified: 'James Bean',
        icon: 'file-archive',
        type: 'file'
      },
      {
        name: 'File text name',
        date: 'April 21, 2021',
        size: '356kb',
        modified: 'James Bean',
        icon: 'file-alt',
        type: 'file'
      }

    ],
    compose: true,
    fullscreenToggled: false,
    minimiseToggled: false,
    people: [

      { name: 'Sandra Adams' },
      { name: 'Ali Connors' },
      { name: 'Trevor Hansen' },
      { name: 'John Hansen' },
      { name: 'James Hansen' },
      { name: 'Paul Hansen' },
      { name: 'Billy Hansen' }
    ],
    ccToggled: false,
    bccToggled: false,
    showMessageSidePanel: false,
    minivariant: false,
    isAdminMode: true,
    menuToggle: true,
    switchTasks: true,
    codeValue: "code value = true",
    caseConfigCaseType: Fixtures.caseConfigCaseType,
    cmOptionsSchema: {
      tabSize: 4,
      mode: {
        name: "javascript",
        json: true
      },
      theme: "base16-light",
      lineNumbers: true,
      line: true
    },
    autocompleteItems: ["Foo", "Bar", "Fizz", "Buzz"],
    rules: {
      required: value => !!value || "Required.",
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || "Email must be in format name@name.com."
      }
    },
    checkbox: true,
    radios: 1,
    switch1: true,
    title: "The Kitchen Sink Demo",
    drawer: null,
    loading: "loading",
    newItemPath: "/users/new",
    orderByOptions: [
      {
        text: "Name",
        value: "displayName"
      },
      {
        text: "Last Login",
        value: "lastSeen"
      },
      {
        text: "Date Created",
        value: "createdAt"
      }
    ],
    bucketProvider: MockDataProvider,
    searchByOptions: ["displayName", "email", "id"],
    searchTerm: "",
    dialog: false,
    dialog2: false,
    caseDocuments: [],
    goToOptions: {
      duration: 500,
      offset: -14,
      easing: "easeInOutCubic"
    },
    messageForSidePanel: {
      subject: "You've won the showcase bonanza prize",
      from: { displayName: "Max Headroom", id: 1 },
      updatedAt: '2021-02-04T09:59:53.189Z'
    }
  }),
  beforeCreate() {
    window.Faye = undefined
  },
  created() {
    this.prepareData()
  },
  methods: {
    toggleAll () {
      if (this.selected.length) this.selected = []
      else this.selected = this.docsTable.slice()
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    prepareData() {
      const currentUser = CurrentUser.currentUser
      const accounts = CurrentUser.accounts
      this.caseDocuments = Fixtures.fileAttachments
      this.$route.params.case_type_id = "2"
      this.$route.params.case_id = "3"
      this.$route.params.search_term = "searchTest"
      this.$route.params.saved_search_id = "1-inbox"

      this.$store.users = Fixtures.manyUsers
      this.$store.commit("receiveCurrentUser", currentUser)
      this.$store.commit("setCurrentlySelectedUser", Fixtures.currentlySelectedUser)
      this.$store.commit("setTeam", Fixtures.manySmallTeams[0])
      this.$store.commit("setTeams", currentUser.account.teams)
      this.$store.commit("setUsers", Fixtures.manyUsers)
      this.$store.commit('setCaseTypes', currentUser.account.caseTypes)
      this.$store.commit('setScreenLayouts', currentUser.screenLayouts)
      this.$store.commit('setNotifications', currentUser.notifications)
      this.$store.commit('setAssignedTasks', currentUser.assignedTasks)
      this.$store.commit('setupRecentNotifications', currentUser.notifications)
      this.$store.commit('setupCaseNotifications', currentUser.notifications)
      this.$store.commit('setSubscriptions', currentUser.subscriptions)
      this.$store.commit("setMyJobs", accounts.jobs)
      this.$store.commit("setAllJobs", accounts.jobs)
      this.$store.commit("setTotalPages", 1)
      this.$store.commit("updateMetrics", Fixtures.metrics)
      this.$store.commit("updateWidgets", [Fixtures.widgetsAndOptions1, Fixtures.widgetsAndOptions2])

      this.$store.commit("updateRecentCases", {
        cases: currentUser.recentCases,
        caseTypes: currentUser.account.caseTypes
      })
      this.$store.commit("setCurrentTimeline", Fixtures.userTimelineData)
      this.$store.commit("setUsers", Fixtures.manyUsers)
      this.$store.commit("setCurrentTimeline", Fixtures.userTimelineData)
      this.$store.commit("forceCurrentCase", Fixtures.caseData)
      this.$store.commit("forceCurrentCaseTemplate", Fixtures.caseConfigCaseType)
      this.$store.commit('setSavedSearches', Fixtures.savedSearches)
      this.$store.commit("receivedCase")

      const self = this
      setTimeout(function() {
        // Wait until updateUsertimelineData is complete to switch off loading flag
        self.$store.commit("setCurrentlySelectedLoading", false)
        self.$store.commit("receivedCase")
      }, 3500)
    },
    updateCodeValue(update) {
      this.codeValue = update
    }
  },
  computed: {
    ...mapState({
      users: state => state.users.all,
      teams: state => state.teams.all,
      currentUser: state => state.currentUser,
      isLoading: state => state.users.loading,
      bucket: state => state.buckets.current.bucket,
      currentCase: state => state.cases.currentlySelected.case
    }),
    fieldData() {
      return Fixtures.fieldData
    },
    userList() {
      return Fixtures.manyUsers
    },
    teamsList() {
      return Fixtures.manySmallTeams
    },
    currentViewers() {
      return Fixtures.currentViewers
    }
  },
  components: {
    PageTitle,
    CardContainer,
    UserEdit,
    TeamEdit,
    CaseConfig,
    CaseEdit,
    CaseDocuments,
    CaseTimeline,
    CaseNotes,
    CaseNotifications,
    CaseConversations,
    CaseTasks,
    DashboardOverview,
    EditCodePane,
    Login,
    ForgotPassword,
    ResetConfirmation,
    ResetPassword,
    CustomDomain,
    MainMenu,
    Logo,
    AccountFAB,
    GlobalFAB,
    PageHeader,
    Buckets,
    BucketGroup,
    BucketView,
    RichText,
    TextField,
    TextArea,
    CurrencyField,
    NumberField,
    CheckBox,
    SelectField,
    SelectFieldMultiple,
    SelectFieldMultipleChips,
    BooleanField,
    AddressField,
    DateField,
    RelationField,
    DocumentField,
    EmbeddedTable,
    ImageViewer,
    BucketNew,
    BucketEdit,
    Notifications,
    SearchBar,
    SearchResults,
    CommsInbox,
    Snackbar,
    BucketGroupEdit,
    Jobs,
    JobsScheduler,
    TasksTable,
    ServiceLevels,
    AllAccounts,
    NewAccount,
    ImportWizard,
    Users,
    Teams,
    AccountConfig,
    EmailWindow,
    CaseTemplateOverview,
    CaseConfigOverview,
    MetricsOverview,
    MetricsDashboard,
    InCaseMenu,
    MessageSidePanel,
    CaseDocumentSidePanel
  }
}
</script>
<style>

</style>

